type BaseNode = {
  type: string;
  id: string;
  name: string;
  parentId: string;
};

export type FileNode = BaseNode & {
  type: 'file';
  url: string;
  contentType: string;
  size: number;
};

export type DirectoryNode = BaseNode & {
  type: 'directory';
};

export type Node = FileNode | DirectoryNode;

export const isFile = (node: Node): node is FileNode => node.type === 'file';
export const isDirectory = (node: Node): node is DirectoryNode => node.type === 'directory';

type NodeType = Node['type'];

export type NodeApiResponse = {
  [T in NodeType]: { type: T; data: Omit<Extract<Node, { type: T }>, 'type'> };
}[NodeType];

export const mapNodeFromApi = <T = Node>(apiNode: NodeApiResponse): T => {
  return {
    ...apiNode.data,
    type: apiNode.type,
  } as T;
};
